import { Button, Icon, ITableStructureItem, Table } from 'modules';
import moment from 'moment';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Routes } from '../../../AppRoutes';
import { ConfigService } from '../../../services/config/config.service';
import { SET_DETAIL_ANNOUNCEMENT } from '../../../services/config/editAnnouncement.reduce';
import { store } from '../../../store';

const AnnouncementCompnt = () => {
  const navigate = useNavigate();

  const structure: ITableStructureItem[] = [
    {
      name: 'Title',
      key: 'title',
      className: 'title',
      render: (item) => {
        return <span>{JSON.parse(item?.title)['en-US']}</span>;
      },
    },
    {
      name: 'Content',
      key: 'content',
      className: 'content',
      render: (item) => (
        <span
          dangerouslySetInnerHTML={{
            __html: JSON.parse(item?.content)['en-US'],
          }}
        ></span>
      ),
    },
    {
      name: 'Image',
      key: 'image',
      render: (item) => (
        <a href={item?.image} target={'_blank'} rel='noreferrer'>
          <img className='image' src={item?.image} alt='' />
        </a>
      ),
    },
    {
      name: 'Created Date',
      key: 'created',
      render: (item) => moment(item?.created).format('DD/MM/y HH:mm:ss'),
    },
    {
      name: 'Expiration Date',
      key: 'expirationDate',
      render: (item) => moment(item?.expirationDate).format('DD/MM/y HH:mm:ss'),
    },
    {
      name: 'Status',
      key: 'status',
      render: (item) => (
        <span className={`status status--${item?.status?.toLowerCase()}`}>
          {item?.status?.toUpperCase()}
        </span>
      ),
    },
    {
      name: 'Actions',
      render: (item) => {
        return (
          <div className='action'>
            <div
              className={`action__edit action__edit--${item?.status?.toLowerCase()}`}
              onClick={() => {
                if (item?.status?.toLowerCase() === 'expired') return;
                store.dispatch({
                  type: SET_DETAIL_ANNOUNCEMENT,
                  data: {
                    ...item,
                    title: JSON.parse(item?.title),
                    content: JSON.parse(item?.content),
                  },
                });
                navigate(Routes.EditAnnouncement.path);
              }}
            >
              <Icon.ActionEditIcon />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Button
        label='New Announcement'
        onClick={() => navigate(Routes.CreateAnnouncement.path)}
        buttonType='success'
        icon={Icon.AddNewIcon}
        className='btnBan mb20'
      />
      <Table
        hasOrderColumn
        itemPerPages={10}
        structure={structure}
        fetchData={async (params) => {
          if (params['fromDate'])
            params['fromDate'] = moment(params['fromDate']).toISOString();
          if (params['toDate'])
            params['toDate'] = moment(params['toDate']).toISOString();
          return ConfigService.getListAnnouncement();
        }}
      />
    </>
  );
};

export default AnnouncementCompnt;
